[
    {
        "id": 10,
        "title": "Create Lockers",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 2
    },
    {
        "id": 20,
        "title": "Mint B-Silver",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 2
    },
    {
        "id": 30,
        "title": "Mine B-Silver",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 1
    },
    {
        "id": 40,
        "title": "Dear Miss Aquarius™ AI",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 50,
        "title": "Install Web App",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 60,
        "title": "Advanced Features",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 70,
        "title": "Use Cases",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 80,
        "title": "Quiz",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 90,
        "title": "Say Hello by Email",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    }
]
